import {
  SET_FOUND_DOM,
  CLEAR_FOUND_AXIOS_SOURCE,
  SET_FOUND_AXIOS_SOURCE
} from '../actions/found'
import { makeSearchParams } from '../actions/search'
import axios from 'axios'

const state = {
  foundDom: null,
  foundCount: null,
  foundAxiosSource: null
}

const getters = {
  getFoundDom: state => state.foundDom,
  getFoundCount: state => state.foundCount
}

const actions = {
  [SET_FOUND_DOM] ({ commit, dispatch, rootState, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      if (data) {
        dispatch(CLEAR_FOUND_AXIOS_SOURCE).then(() => {
          const cancelSource = axios.CancelToken.source()
          commit(SET_FOUND_AXIOS_SOURCE, cancelSource)
          const params = { ...makeSearchParams(rootState.search, rootGetters), count: 1 }
          this._vm.$api.catalog.search(params, { cancelToken: cancelSource.token }).then((response) => {
            commit(SET_FOUND_DOM, { dom: data.dom || null, count: response.data })
            commit(SET_FOUND_AXIOS_SOURCE, null)
            resolve(response)
          }).catch(err => {
            if (!axios.isCancel(err)) {
              resolve()
            } else {
              reject(err)
            }
          })
        }).catch(err => {
          reject(err)
        })
      } else {
        commit(SET_FOUND_DOM, null)
        resolve()
      }
    })
  },
  [CLEAR_FOUND_AXIOS_SOURCE]: ({ commit, state }) => {
    return new Promise((resolve) => {
      if (state.foundAxiosSource) {
        if (state.foundAxiosSource) {
          state.foundAxiosSource.cancel('Operation canceled due to new request.')
          commit(SET_FOUND_AXIOS_SOURCE, null)
        }
      }
      resolve()
    })
  }
}

const mutations = {
  [SET_FOUND_DOM]: (state, data) => {
    const { dom, count } = data || {}
    state.foundDom = dom || null
    state.foundCount = count || null
  },
  [SET_FOUND_AXIOS_SOURCE]: (state, source) => {
    state.foundAxiosSource = source
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
